import { DocumentNode } from 'graphql';
import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { IShippingMethodSchemaPartial } from '../../type/shippingMethod';
import { ITranslationSubTypeInput } from '../../type/_inputTypes/translation';

export interface ICreateGetsShippingMethodMutationFields {
    name: ITranslationSubTypeInput[];
    description: ITranslationSubTypeInput[];
    status: boolean
    shippingMethodType: string
    company: string

    getsShippingConfigUserId: string
    getsShippingConfigEmailId: string
    getsShippingConfigPhoneId: string
    getsShippingConfigAddressId: string
}


export interface ICreateGetsShippingMethodMutationResponseFields {
    createdGetsShippingMethod: IShippingMethodSchemaPartial;
}


export function createGetsShippingMethodMutation(fragment: string): DocumentNode {
  return gql`
        mutation createGetsShippingMethod (
        $name: [TranslationSubTypeInput]!,
$description: [TranslationSubTypeInput]!,
$status: Boolean!,
$shippingMethodType: String!,
$company: String,
$getsShippingConfigUserId: String!,
$getsShippingConfigEmailId: String!,
$getsShippingConfigPhoneId: String!,
$getsShippingConfigAddressId: String!
        ) {
        createGetsShippingMethod (
        name: $name,
description: $description,
status: $status,
shippingMethodType: $shippingMethodType,
company: $company,
getsShippingConfigUserId: $getsShippingConfigUserId,
getsShippingConfigEmailId: $getsShippingConfigEmailId,
getsShippingConfigPhoneId: $getsShippingConfigPhoneId,
getsShippingConfigAddressId: $getsShippingConfigAddressId
        ) {
        ...fragment
        }
        }
        fragment fragment on CreateGetsShippingMethodMutationResponse {
        code
        success
        message
        ${fragment}
        }
    `;
}

export function useCreateGetsShippingMethodMutation<TData extends Partial<ICreateGetsShippingMethodMutationResponseFields>>(
  fragment: string, options?: MutationHookOptions<{ createGetsShippingMethod: TData },
        ICreateGetsShippingMethodMutationFields>,
) {
  return useMutation<{ createGetsShippingMethod: TData },
      ICreateGetsShippingMethodMutationFields>(
        createGetsShippingMethodMutation(fragment), options,
      );
}
